import script from "./CopySlideDeck.vue?vue&type=script&setup=true&lang=js"
export * from "./CopySlideDeck.vue?vue&type=script&setup=true&lang=js"

import "./CopySlideDeck.vue?vue&type=style&index=0&id=12173fd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12173fd9"]])

export default __exports__